import { Col, Div, Span, Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { Button } from "../../../components/Button/index";
import styled from "styled-components";
import logoPulpey from "../../../assets/images/logo.svg";
import { containsHTML, getUserInfo } from "../../../utilities/helpers";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import useSaveRegisterActivityNews from "../hooks/useSaveRegisterUserActivity";
//import VideoModal from "./VideoModal";

const CardContainer = styled.div`
  break-inside: avoid;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 18px;
  background: ${({ theme }) => theme.colors.whiteBlur};
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const CardSkeletonContainer = styled.div`
  break-inside: avoid;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 18px;
  background: ${({ theme }) => theme.colors.whiteBlur};
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const TimerBadge = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.57);
  color: ${theme.colors.white};
  padding: 4px 12px;
  border-radius: 9999px;
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: ${theme.zIndex.base + 1};
`;

const BannerCardSkeleton = ({ isMobile }) => {
  return (
    <CardSkeletonContainer>
      <Div
        width="100%"
        height="120px"
        radius="12px"
        mb="15px"
        style={{
          backgroundColor: theme.colors.blue50
        }}
      />

      <Col
        width="100%"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <Div align="center" m="15px 0" gap="8px" style={{ flexShrink: 0 }}>
          <Skeleton.Avatar active size="small" shape="circle" />
          <Skeleton.Input active size="small" style={{ width: "60%" }} />
        </Div>

        <Skeleton.Input
          active
          size="small"
          style={{ width: "100%", height: "20px", marginBottom: "10px" }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: "90%", height: "20px", marginBottom: "10px" }}
        />
        <Skeleton.Input
          active
          size="small"
          style={{ width: "80%", height: "20px", marginBottom: "15px" }}
        />

        <Div align="center" style={{ marginTop: "auto", flexShrink: 0 }}>
          <Skeleton.Button
            active
            size="small"
            style={{ width: !isMobile ? "157px" : "140px", height: "40px" }}
          />
        </Div>
      </Col>
    </CardSkeletonContainer>
  );
};

export const BannerCardsSkeletonList = ({ count = 3, isMobile }) => {
  return (
    <>
      {Array(count).fill().map((_, index) => (
        <BannerCardSkeleton key={index} isMobile={isMobile} />
      ))}
    </>
  );
};

const CountdownTimer = ({ expirationDate, setHasExpired }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(expirationDate) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeRemaining, setTimeRemaining] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [expirationDate]);

  const getTimeString = () => {
    let days = timeRemaining.days > 0 ? `${timeRemaining.days}d ` : "";
    let hours = timeRemaining.hours > 0 ? `${timeRemaining.hours}h ` : "";
    let minutes =
      timeRemaining.minutes > 0 && timeRemaining.days === 0
        ? `${timeRemaining.minutes}m `
        : "";
    let seconds =
      timeRemaining.seconds > 0 &&
      timeRemaining.days === 0 &&
      timeRemaining.hours === 0
        ? `${timeRemaining.seconds}s`
        : "";

    return `${days}${hours}${minutes}${seconds}`.trim() || "0s";
  };

  useEffect(() => {
    if(Object.keys(timeRemaining).length == 0) {
      setHasExpired(true);
    }
  }, [Object.keys(timeRemaining)])

  return (
    <div style={{ position: "relative" }}>
      <TimerBadge>
        {Object.keys(timeRemaining).length > 0 ? (
          <>
            <Span color="#fff" size={theme.fonts.size.sm} weight="500">Finaliza en:</Span>
            <Span color="#fff" size="0.875rem" weight="700">{getTimeString()}</Span>
          </>
        ) : (
          <Span color="#fff" size={theme.fonts.size.sm} weight="700">Finalizó</Span>
        )}
        
      </TimerBadge>
    </div>
  );
};

export const BannerCard = ({ item, isMobile, setActiveKey, setEditMyAccount, onCardClick }) => {
  const [hasExpired, setHasExpired] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { nameid } = getUserInfo();
  const saveRegisterActivityNews = useSaveRegisterActivityNews(nameid, item.id);

  const defaultVideoThumbnail = 'https://static.wixstatic.com/media/77cd08_24c0c18c68784afba36be89b9064b690~mv2.png';

  const handleButtonClick = async(e) => {
    if (hasExpired) return;

    else if (item.linkTypes == "survey_internal") {
      //console.log('SURVEY INTERNO')
      onCardClick(item);
    }

    else if(item.linkTypes == "internal") {
      //console.log('ENALCE INTERNO')
      if(item.code == 'edit-user') {
          setEditMyAccount(true);
          setTimeout(() => {setActiveKey(item.actionUrl);}, 500)
      } else {
          setActiveKey(item.actionUrl);
      }
    } 

    else if(item.linkTypes == "external" || item.linkTypes === "video_and_external") {
      //console.log('ENALCE EXTERNAL')
      if (item.actionUrl) {
        window.open(item.actionUrl, '_blank', 'noopener,noreferrer');
      }   
    }

    else if(item.linkTypes === "video") {
      //console.log('VIDEO')
      setShowVideoModal(true);
    }

    saveRegisterActivityNews.reset;
    saveRegisterActivityNews.mutate(
      {},
      {
        onSuccess: (res) => {
          //console.log(res, 'RESPEUSTA DE ACTIVIDAD EN EL BANNER');
        },
        onError: (err) => {
          if (err?.response?.data?.errors) {
            const errorMessages = Object.values(err.response.data.errors)
              .flat()
              .join(", ");
           //console.log(errorMessages);
          }
        }
      }
    );

    // Ejemplo 2: Enviando body y params (si el endpoint lo requiere)
    /* saveRegisterActivityNews.mutate(
      {
        body: { 
          extraData: "valor adicional" 
        },
        params: {
          userId: nameid,
          newsAndPromotionId: newsId
        }
      },
      { ... } // Callbacks
    ); */
    console.log(item.id, 'ID DEL BANNER INFORMATIVO ============================')
  };

  const renderMediaContent = () => {
    if (item.linkTypes === "video" || item.linkTypes === "video_and_external") {
      return (
        <Div 
          width="100%" 
          height="120px" 
          radius="12px" 
          mb="15px"
          align="center"
          justify="center"
          style={{
            backgroundImage: `url(${item.imageUrl || defaultVideoThumbnail})`,
            backgroundSize: "contain",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'pointer'
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowVideoModal(true);
            saveRegisterActivityNews.reset;
            saveRegisterActivityNews.mutate(
              {},
              {
                onSuccess: (res) => {
                  //console.log(res, 'RESPEUSTA DE ACTIVIDAD EN EL BANNER');
                },
                onError: (err) => {
                  if (err?.response?.data?.errors) {
                    const errorMessages = Object.values(err.response.data.errors)
                      .flat()
                      .join(", ");
                  //console.log(errorMessages);
                  }
                }
              }
            )
          }}
        >
          {/* Overlay con icono de play */}
          <Div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Div
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: theme.colors.white,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19L19 12L8 5Z" fill={theme.colors.blue500}/>
              </svg>
            </Div>
          </Div>
        </Div>
      );
    } else if (item.imageUrl) {
      return (
        <Div 
          width="100%" 
          height="120px" 
          radius="12px" 
          align="center"
          justify="center"
          mb="15px"
          style={{
            backgroundImage: `url(${item.imageUrl})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            transition: 'all 0.3s ease'
          }}
        />
      );
    }
    return null;
  };

  return (
    <>
      <CardContainer /* onClick={handleButtonClick} */ key={item.id} disabled={hasExpired}>
        {item.expirationDate && (
          <CountdownTimer expirationDate={item.expirationDate} setHasExpired={setHasExpired}/>
        )}
        
        {renderMediaContent()}
        
        <Col 
          width="100%" 
          style={{ 
            flex: '1', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center',
            marginTop: item.expirationDate && !item.imageUrl ? "25px" : ""
          }}>
          <Div align="center" m="15px 0" gap="8px" style={{ flexShrink: 0 }}>
            {item.icon && (
              <Div width="28px" height="28px">
                {item.icon}
              </Div>
            )}
            {containsHTML(item.title) ? (
              <Text
                size={theme.fonts.size.h4}
                color={theme.colors.green300}
                weight={theme.fonts.weight.bold}
                align="left"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
            ) : (
              <Text
                size={theme.fonts.size.h4}
                color={theme.colors.green300}
                weight={theme.fonts.weight.bold}
                align="left"
              >
                {item.title}
              </Text>
            )}
          </Div>

          {containsHTML(item.description) ? (
            <Text
              size={theme.fonts.size.h6}
              color={theme.colors.white}
              style={{
                marginBottom: '15px',
                ...(item.imageUrl && {
                  display: '-webkit-box',
                  //WebkitLineClamp: 6,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }),
              }}
              dangerouslySetInnerHTML={{ __html: `${item.description}` }}
            />
          ) : (
            <Text
              size={theme.fonts.size.h6}
              color={theme.colors.white}
              style={{
                marginBottom: '15px',
                ...(item.imageUrl && {
                  display: '-webkit-box',
                  //WebkitLineClamp: 6,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }),
              }}
            >
              {item.description}
            </Text> 
          )}

          {(item.actionUrl || item.linkTypes === "video" || item.linkTypes === "video_and_external") && (
            <Div 
              width="100%" 
              align="center" 
              style={{ marginTop: 'auto', flexShrink: 0 }}
            >
              <Button
                variant="outlined"
                width={!isMobile ? "157px" : "140px"}
                height="40px"
                onClick={(e) => {
                  e.stopPropagation();
                  handleButtonClick();
                }}
              >
                {item.actionText || 'Ver más'}
              </Button>
            </Div>
          )}
        </Col>
      </CardContainer>

      {/* Modal para el video - Ahora usa actionUrl */}
      {showVideoModal && (item.linkTypes === "video" || item.linkTypes === "video_and_external") && (
        <VideoModal 
          videoUrl={item.code} // Usamos actionUrl para el video
          onClose={() => setShowVideoModal(false)}
          isMobile={isMobile}
          open={showVideoModal}
        />
      )}
    </>
  );
};

// Componente VideoModal actualizado
const VideoModal = ({ videoUrl, onClose, isMobile }) => {
  const [showFallbackControls, setShowFallbackControls] = useState(false);
  
  const handleIframeLoad = () => {
    setTimeout(() => {
      const iframe = document.querySelector('iframe');
      if (iframe && !iframe.contentWindow.document.querySelector('.ytp-chrome-bottom')) {
        setShowFallbackControls(true);
      }
    }, 1000);
  };

  const renderFallbackControls = () => {
    if (!showFallbackControls) return null;

    return (
      <div style={{
        position: 'absolute',
        bottom: '10px',
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        gap: '15px',
        zIndex: 10,
        padding: '10px',
        background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
      }}>
        <button 
          onClick={() => {
            const iframe = document.querySelector('iframe');
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            padding: '8px 15px',
            borderRadius: '20px',
            fontSize: '14px'
          }}
        >
          Pausa
        </button>
        <button 
          onClick={() => {
            const iframe = document.querySelector('iframe');
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            padding: '8px 15px',
            borderRadius: '20px',
            fontSize: '14px'
          }}
        >
          Reproducir
        </button>
        <button 
          onClick={() => {
            const iframe = document.querySelector('iframe');
            iframe.requestFullscreen().catch(err => {
              console.error('Error al intentar pantalla completa:', err);
            });
          }}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: 'white',
            padding: '8px 15px',
            borderRadius: '20px',
            fontSize: '14px'
          }}
        >
          Pantalla completa
        </button>
      </div>
    );
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.95)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: isMobile ? '0' : '20px'
    }}>
      <div style={{
        width: isMobile ? '100%' : '90%',
        maxWidth: '900px',
        position: 'relative',
        aspectRatio: '16/9',
        height: isMobile ? '100%' : 'auto'
      }}>
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: isMobile ? '15px' : '0px',
            right: isMobile ? '15px' : '0',
            background: isMobile ? 'rgba(0,0,0,0.5)' : 'transparent',
            border: 'none',
            color: theme.colors.white,
            fontSize: isMobile ? '24px' : '28px',
            cursor: 'pointer',
            zIndex: 20,
            width: isMobile ? '40px' : 'auto',
            height: isMobile ? '40px' : 'auto',
            borderRadius: isMobile ? '50%' : '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label="Cerrar video"
        >
          ×
        </button>
        
        <div style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <iframe
            src={`${videoUrl}?autoplay=1&controls=1&showinfo=0&modestbranding=1&rel=0`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
            playsInline
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            onLoad={handleIframeLoad}
          />
          {renderFallbackControls()}
        </div>
      </div>
    </div>
  );
};
